<template>
  <svg
    v-if="name === 'camera'"
    class="fill-current w-5 h-5"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 420.8 420.8"
  >
    <path
      d="M406.8 96.4c-8.4-8.8-20-14-33.2-14h-66.4v-.8c0-10-4-19.6-10.8-26a36.6 36.6 0 00-26-10.8h-120c-10.4 0-19.6 4-26.4 10.8a36.6 36.6 0 00-10.8 26v.8h-66c-13.2 0-24.8 5.2-33.2 14-8.4 8.4-14 20.4-14 33.2v199.2C0 342 5.2 353.6 14 362c8.4 8.4 20.4 14 33.2 14h326.4c13.2 0 24.8-5.2 33.2-14 8.4-8.4 14-20.4 14-33.2V129.6c0-13.2-5.2-24.8-14-33.2zM400 328.8h-.4c0 7.2-2.8 13.6-7.6 18.4s-11.2 7.6-18.4 7.6H47.2c-7.2 0-13.6-2.8-18.4-7.6-4.8-4.8-7.6-11.2-7.6-18.4V129.6c0-7.2 2.8-13.6 7.6-18.4s11.2-7.6 18.4-7.6h77.2c6 0 10.8-4.8 10.8-10.8V81.2c0-4.4 1.6-8.4 4.4-11.2s6.8-4.4 11.2-4.4h119.6c4.4 0 8.4 1.6 11.2 4.4 2.8 2.8 4.4 6.8 4.4 11.2v11.6c0 6 4.8 10.8 10.8 10.8H374c7.2 0 13.6 2.8 18.4 7.6s7.6 11.2 7.6 18.4v199.2z"
    />
    <path
      d="M210.4 130.8c-27.2 0-52 11.2-69.6 28.8-18 18-28.8 42.4-28.8 69.6s11.2 52 28.8 69.6c18 18 42.4 28.8 69.6 28.8s52-11.2 69.6-28.8c18-18 28.8-42.4 28.8-69.6s-11.2-52-28.8-69.6a98.57 98.57 0 00-69.6-28.8zM264.8 284c-14 13.6-33.2 22.4-54.4 22.4S170 297.6 156 284c-14-14-22.4-33.2-22.4-54.4 0-21.2 8.8-40.4 22.4-54.4 14-14 33.2-22.4 54.4-22.4s40.4 8.8 54.4 22.4c14 14 22.4 33.2 22.4 54.4.4 21.2-8.4 40.4-22.4 54.4z"
    />
    <circle cx="352.8" cy="150" r="19.6" />
  </svg>
  <svg
    v-else-if="name === 'sys-info'"
    class="fill-current w-5 h-5"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path
      d="M256 0C114.5 0 0 114.5 0 256s114.5 256 256 256 256-114.5 256-256S397.5 0 256 0zm0 472c-119.4 0-216-96.61-216-216 0-119.4 96.61-216 216-216 119.4 0 216 96.61 216 216 0 119.4-96.62 216-216 216z"
    />
    <path
      d="M256 214.33a20 20 0 00-20 20v128.8a20 20 0 1040 0v-128.8a20 20 0 00-20-20z"
    />
    <circle cx="256" cy="162.84" r="27" />
  </svg>
  <svg
    v-else-if="name === 'summary'"
    class="fill-current w-5 h-5"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path
      d="M488.4 492h-21.93V173.54a26.91 26.91 0 00-26.89-26.89h-49.02a26.91 26.91 0 00-26.88 26.89V492h-55.7V317.82a26.91 26.91 0 00-26.88-26.88h-49.02a26.91 26.91 0 00-26.88 26.88V492h-55.7v-90.2a26.91 26.91 0 00-26.88-26.89H73.6a26.91 26.91 0 00-26.88 26.89V492H23.6a10 10 0 100 20h464.8a10 10 0 100-20zm-358.9 0H66.72v-90.2c0-3.8 3.08-6.89 6.88-6.89h49.02c3.8 0 6.88 3.1 6.88 6.89V492zM288 492h-62.8V317.82c0-3.79 3.1-6.88 6.89-6.88h49.02c3.8 0 6.88 3.09 6.88 6.88V492zm158.48 0h-62.8V173.54c0-3.8 3.1-6.89 6.89-6.89h49.02c3.8 0 6.89 3.1 6.89 6.89V492zM466.44 10.52A9.97 9.97 0 00455.95.02l-.48-.02h-60.5a10 10 0 100 20h37.35l-98.85 98.86-37.28-37.28a10 10 0 00-14.15 0L102.27 261.35a10 10 0 0014.15 14.14l172.7-172.7 37.28 37.28a10 10 0 0014.14 0L446.47 34.14v33.81a10 10 0 1020 0V11l-.03-.48z"
    />
    <circle cx="75.64" cy="303.31" r="10" />
  </svg>
  <svg
    v-else-if="name === 'recording'"
    class="fill-current w-5 h-5"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 426.67 426.67"
  >
    <path
      d="M213.33 106.67c-58.88 0-106.66 47.78-106.66 106.66S154.45 320 213.33 320 320 272.21 320 213.33s-47.79-106.66-106.67-106.66z"
    />
    <path
      d="M213.33 0C95.47 0 0 95.47 0 213.33s95.47 213.34 213.33 213.34 213.34-95.47 213.34-213.34S331.2 0 213.33 0zm0 384c-94.29 0-170.66-76.37-170.66-170.67S119.04 42.67 213.33 42.67 384 119.04 384 213.33 307.63 384 213.33 384z"
    />
  </svg>
  <svg
    v-else-if="name === 'accessibility'"
    class="fill-current w-5 h-5"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512.02 512.02"
  >
    <path
      d="M492.6 182.68l-59.04-8.7a204 204 0 00-19.52-34.44l22.46-57.51c4.16-10.88-.13-22.87-9.92-28.36L341.78 3.3a22.67 22.67 0 00-29.74 5.67l-36.8 48.36a165.9 165.9 0 00-38.48 0L199.94 8.9c-6.96-9.03-19.31-11.48-29.61-5.68l-84.66 50.3c-9.64 5.4-14.03 17.54-10.13 28.57l22.42 57.37a196.99 196.99 0 00-19.5 34.5l-58.85 8.68C8.42 184.09 0 193.96 0 205.59v100.89c0 11.64 8.43 21.52 19.41 22.9l59.05 8.71a204 204 0 0019.52 34.43l-22.46 57.52c-4.16 10.9.13 22.89 9.92 28.35l85.12 50.6c3.63 2.03 7.55 3.01 11.41 3.01 6.87 0 13.55-3.1 18.03-8.92l36.78-48.36a200.25 200.25 0 0038.5 0l36.83 48.43c6.93 9 19.28 11.48 29.6 5.7l24.54-14.6a10.67 10.67 0 00-10.9-18.32l-26.3 14.27-40.47-53.23a10.72 10.72 0 00-9.86-4.11c-12.93 1.66-32.43 1.66-45.35 0a10.79 10.79 0 00-9.86 4.11l-42.24 53.55-85.12-50.6c-.81-.47-.94-1.5-.66-2.2l24.53-62.8c1.33-3.42.83-7.24-1.32-10.18-9.92-13.63-17.37-26.82-22.74-40.3a10.69 10.69 0 00-8.36-6.61l-65-9.58c-.07 0-1.14-1.8-1.2-1.8V205.58l1.2-1.81 65-9.58a10.66 10.66 0 008.36-6.62 175 175 0 0122.68-40.19 10.67 10.67 0 001.38-10.26L95.6 74.65c-.3-.9-.03-2.2.8-2.67l86.66-50.13 40.47 53.22c2.3 3.01 6.02 4.55 9.86 4.12 17.75-2.28 27.6-2.28 45.35 0a10.7 10.7 0 009.86-4.12l42.24-53.52 85.1 50.58c.8.47.96 1.5.68 2.2l-24.53 62.8a10.66 10.66 0 001.32 10.18c9.92 13.63 17.36 26.81 22.74 40.3 1.4 3.54 4.6 6.05 8.36 6.6l65 9.59c.07.02 1.14 1.81 1.2 1.81V306.5l-1.2 1.79-41.68 6.14a10.64 10.64 0 00-9 12.1 10.6 10.6 0 0012.1 9l41.47-6.12c11.18-1.43 19.62-11.29 19.62-22.94V205.6c-.02-11.63-8.42-21.5-19.41-22.91z"
    />
    <path
      d="M380.33 301.23c-11.9-11.9-18.39-27.01-17.75-41.45 1.13-26.33-9.87-51.46-33.66-76.82-20.35-21.7-47.68-34-74.26-33.63-23.7.3-46.3 8.58-65.35 23.96a10.64 10.64 0 001.22 17.43l65.2 39.1a57.99 57.99 0 01-31.26 45.98l-58.37-35.03c-3.22-1.94-7.7-1.8-11.03.02a10.67 10.67 0 00-5.54 8.75c-1.75 29.74 8.5 58 28.86 79.6a107.17 107.17 0 0077.63 33.48c7.85 0 15.73-1.02 24.37-3.22l136.17 136.17a55.47 55.47 0 0039.55 16.39 55.97 55.97 0 0055.9-55.92 55.55 55.55 0 00-16.4-39.53L380.34 301.23zm75.78 189.42h-.05c-9.23 0-17.92-3.6-24.44-10.14L291.05 339.95a10.7 10.7 0 00-10.58-2.69c-9.13 2.75-16.88 4.03-24.43 4.03a84.53 84.53 0 01-62.1-26.8 84.55 84.55 0 01-22.27-45.5l46.87 28.12c3.13 1.88 6.97 2 10.26.4l4.5-2.24a79.32 79.32 0 0044.05-71.3c0-3.75-1.98-7.22-5.18-9.14l-56.32-33.8a82.8 82.8 0 0139.08-10.38c20.59-.3 42.18 9.53 58.43 26.88 19.93 21.26 28.8 40.74 27.9 61.3-.89 20.4 7.86 41.35 23.99 57.48l115.28 115.3a34.28 34.28 0 0110.14 24.48 34.56 34.56 0 01-34.56 34.56z"
    />
  </svg>
  <svg
    v-else-if="name === 'settings'"
    class="fill-current w-5 h-5"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 368 368"
  >
    <path
      d="M344 144h-29.95a135.4 135.4 0 00-9.8-23.66l21.17-21.16a23.86 23.86 0 007.02-16.99c0-6.41-2.5-12.45-7.02-16.97l-22.64-22.64c-9.05-9.05-24.9-9.08-33.96 0l-21.16 21.16c-7.53-4-15.46-7.28-23.66-9.8V24c0-13.23-10.77-24-24-24h-32c-13.23 0-24 10.77-24 24v29.95c-8.2 2.52-16.12 5.8-23.66 9.8L99.17 42.57a24.04 24.04 0 00-33.95 0L42.57 65.22a24.05 24.05 0 000 33.96l21.16 21.16c-4 7.54-7.27 15.47-9.8 23.67H24c-13.23 0-24 10.77-24 24v32C0 213.23 10.77 224 24 224h29.95c2.52 8.2 5.8 16.12 9.8 23.66l-21.17 21.17a24.04 24.04 0 000 33.95l22.64 22.65a24.05 24.05 0 0033.96 0l21.16-21.16c7.54 4 15.47 7.27 23.67 9.8V344c0 13.23 10.77 24 24 24h32c13.23 0 24-10.77 24-24v-29.95c8.2-2.52 16.13-5.8 23.66-9.8l21.16 21.17c9.07 9.07 24.91 9.05 33.95 0l22.64-22.64a23.85 23.85 0 007.03-16.97c0-6.43-2.5-12.45-7.03-16.98l-21.16-21.17c4-7.53 7.28-15.46 9.8-23.66H344c13.23 0 24-10.77 24-24v-32c0-13.23-10.77-24-24-24zm8 56a8 8 0 01-8 8h-36a8 8 0 00-7.74 6 120.25 120.25 0 01-12.84 30.98 8.01 8.01 0 001.24 9.72l25.44 25.44a7.95 7.95 0 012.33 5.67c0 2.15-.83 4.16-2.33 5.66l-22.64 22.64c-3.01 3.01-8.32 3.01-11.33 0l-25.44-25.44a8 8 0 00-9.73-1.23c-9.62 5.68-20.04 10-30.97 12.82-3.52.9-5.99 4.1-5.99 7.74v36a8 8 0 01-8 8h-32c-4.4 0-8-3.6-8-8v-36a8 8 0 00-6-7.74 119.95 119.95 0 01-30.98-12.83 8 8 0 00-9.73 1.23L87.87 314.1a8.02 8.02 0 01-11.33 0l-22.64-22.64a8.01 8.01 0 010-11.32l25.44-25.44a8 8 0 001.23-9.72c-5.68-9.64-10-20.05-12.82-30.98-.9-3.53-4.1-6-7.74-6H24c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h36a8 8 0 007.74-6 119.95 119.95 0 0112.83-30.98 7.99 7.99 0 00-1.23-9.72L53.9 87.86a8.02 8.02 0 010-11.32L76.54 53.9a8.02 8.02 0 0111.32 0l25.44 25.44a7.98 7.98 0 009.72 1.23c9.64-5.68 20.05-10 30.98-12.83a8 8 0 006-7.74V24c0-4.4 3.6-8 8-8h32a8 8 0 018 8v36a8 8 0 006 7.74 119.83 119.83 0 0130.97 12.83 7.99 7.99 0 009.73-1.23l25.44-25.44a8.21 8.21 0 0111.32 0l22.64 22.64c1.5 1.5 2.34 3.52 2.34 5.66s-.83 4.16-2.34 5.66l-25.44 25.44a8 8 0 00-1.23 9.72c5.69 9.64 10 20.05 12.83 30.98.9 3.53 4.1 6 7.74 6h36a8 8 0 018 8v32z"
    />
    <path
      d="M184 112c-39.7 0-72 32.3-72 72s32.3 72 72 72 72-32.3 72-72-32.3-72-72-72zm0 128c-30.88 0-56-25.12-56-56s25.12-56 56-56c30.87 0 56 25.12 56 56s-25.13 56-56 56z"
    />
  </svg>
  <svg
    v-else-if="name === 'select'"
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    enable-background="new 0 0 512 512"
    class="fill-current w-5 h-5"
    viewBox="0 0 512 512"
  >
    <g>
      <path
        d="m174 240h-108c-36.393 0-66-29.607-66-66v-108c0-36.393 29.607-66 66-66h108c36.393 0 66 29.607 66 66v108c0 36.393-29.607 66-66 66zm-108-208c-18.748 0-34 15.252-34 34v108c0 18.748 15.252 34 34 34h108c18.748 0 34-15.252 34-34v-108c0-18.748-15.252-34-34-34z"
      />
      <path
        d="m446 240h-108c-36.393 0-66-29.607-66-66v-108c0-36.393 29.607-66 66-66h108c36.393 0 66 29.607 66 66v108c0 36.393-29.607 66-66 66zm-108-208c-18.748 0-34 15.252-34 34v108c0 18.748 15.252 34 34 34h108c18.748 0 34-15.252 34-34v-108c0-18.748-15.252-34-34-34z"
      />
      <path
        d="m392 512c-66.168 0-120-53.832-120-120s53.832-120 120-120 120 53.832 120 120-53.832 120-120 120zm0-208c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88z"
      />
      <path
        d="m174 512h-108c-36.393 0-66-29.607-66-66v-108c0-36.393 29.607-66 66-66h108c36.393 0 66 29.607 66 66v108c0 36.393-29.607 66-66 66zm-108-208c-18.748 0-34 15.252-34 34v108c0 18.748 15.252 34 34 34h108c18.748 0 34-15.252 34-34v-108c0-18.748-15.252-34-34-34z"
      />
    </g>
  </svg>
  <!-- logout icon -->
  <svg
    v-else-if="name === 'logout'"
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current w-5 h-5"
    viewBox="0 -10 490.66667 490"
  >
    <path
      d="m474.667969 251h-309.335938c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h309.335938c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
    />
    <path
      d="m250.667969 336.332031c-4.097657 0-8.191407-1.554687-11.308594-4.691406l-85.332031-85.332031c-6.25-6.253906-6.25-16.386719 0-22.636719l85.332031-85.332031c6.25-6.25 16.382813-6.25 22.636719 0 6.25 6.25 6.25 16.382812 0 22.632812l-74.027344 74.027344 74.027344 74.027344c6.25 6.25 6.25 16.382812 0 22.632812-3.136719 3.117188-7.234375 4.671875-11.328125 4.671875zm0 0"
    />
    <path
      d="m234.667969 469.667969c-129.386719 0-234.667969-105.28125-234.667969-234.667969s105.28125-234.667969 234.667969-234.667969c97.085937 0 182.804687 58.410157 218.410156 148.824219 3.242187 8.210938-.8125 17.492188-9.023437 20.753906-8.214844 3.203125-17.496094-.789062-20.757813-9.042968-30.742187-78.082032-104.789063-128.535157-188.628906-128.535157-111.746094 0-202.667969 90.925781-202.667969 202.667969s90.921875 202.667969 202.667969 202.667969c83.839843 0 157.886719-50.453125 188.628906-128.511719 3.242187-8.257812 12.523437-12.246094 20.757813-9.046875 8.210937 3.242187 12.265624 12.542969 9.023437 20.757813-35.605469 90.390624-121.324219 148.800781-218.410156 148.800781zm0 0"
    />
  </svg>
  <!-- maximize icon -->
  <svg
    v-else-if="name === 'maximize'"
    class="fill-current w-5 h-5"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    id="Capa_1"
    viewBox="0 0 402.996 402.996"
    style="enable-background: new 0 0 402.996 402.996"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M392.996,1.985H258.33c-5.523,0-10,4.477-10,10V31.01c0,5.523,4.477,10,10,10h78.046L224.955,152.431    c-3.905,3.905-3.905,10.237,0,14.142l13.453,13.453c1.953,1.953,4.512,2.929,7.07,2.929c2.56,0,5.119-0.977,7.071-2.929    L363.972,68.604v78.047c0,5.523,4.478,10,10,10h19.024c5.523,0,10-4.477,10-10V11.985C402.996,6.462,398.52,1.985,392.996,1.985z"
        />
        <path
          d="M66.62,41.01h78.046c5.523,0,10-4.477,10-10V11.985c0-5.523-4.477-10-10-10H10c-5.523,0-10,4.477-10,10v134.666    c0,5.523,4.477,10,10,10h19.024c5.523,0,10-4.477,10-10V68.604l111.422,111.421c1.952,1.953,4.512,2.929,7.071,2.929    s5.119-0.977,7.071-2.929l13.453-13.453c3.905-3.905,3.905-10.237,0-14.142L66.62,41.01z"
        />
        <path
          d="M392.996,246.344h-19.024c-5.522,0-10,4.478-10,10v78.047L252.55,222.97c-3.903-3.905-10.237-3.905-14.142,0    l-13.453,13.453c-3.905,3.904-3.905,10.236,0,14.142l111.421,111.421H258.33c-5.523,0-10,4.477-10,10v19.023    c0,5.523,4.477,10,10,10h134.666c5.523,0,10-4.477,10-10V256.344C402.996,250.821,398.52,246.344,392.996,246.344z"
        />
        <path
          d="M164.588,222.97c-3.905-3.905-10.238-3.905-14.142,0L39.024,334.392v-78.047c0-5.523-4.477-10-10-10H10    c-5.523,0-10,4.477-10,10v134.666c0,5.523,4.477,10,10,10h134.666c5.523,0,10-4.477,10-10v-19.023c0-5.523-4.477-10-10-10H66.62    l111.421-111.422c3.905-3.904,3.905-10.236,0-14.143L164.588,222.97z"
        />
      </g>
    </g>
  </svg>
  <svg
    class="fill-current"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="35px"
    v-else-if="name === 'live-streaming'"
  >
    <g>
      <path
        d="m17.5812 17.7268c-.1509.2314-.0856.5412.1457.692s.5411.0855.6919-.1458c1.1765-1.8043 1.8601-3.9596 1.8601-6.2731 0-2.31342-.6836-4.46873-1.8601-6.27305-.1508-.23132-.4606-.29657-.6919-.14575s-.2966.46061-.1457.69192c1.0737 1.6468 1.6977 3.61322 1.6977 5.72688 0 2.1137-.624 4.0802-1.6977 5.7269z"
      />
      <path
        d="m6.05202 5.58122c.23131.15082.29657.4606.14575.69192-1.07374 1.64679-1.69777 3.61322-1.69777 5.72696 0 2.1136.62403 4.0801 1.69777 5.7269.15082.2313.08556.5411-.14575.6919-.23132.1508-.5411.0856-.69193-.1458-1.17644-1.8043-1.86009-3.9596-1.86009-6.273 0-2.31351.68365-4.46882 1.8601-6.27314.15082-.23131.4606-.29657.69192-.14574z"
      />
      <path
        d="m15.5939 14.5344c-.1611.2243-.1098.5367.1145.6978.2243.161.5367.1097.6978-.1146.6479-.9024 1.0296-2.0097 1.0296-3.2046s-.3817-2.30221-1.0296-3.20465c-.1611-.22431-.4735-.27559-.6978-.11453s-.2756.47346-.1145.69777c.5299.73811.8419 1.64261.8419 2.62141s-.312 1.8833-.8419 2.6214z"
      />
      <path
        d="m8.22737 8.59388c.22431.16106.27559.47346.11453.69777-.52996.73815-.8419 1.64255-.8419 2.62135 0 .9789.31193 1.8833.8419 2.6214.16106.2244.10978.5368-.11453.6978-.22431.1611-.53671.1098-.69777-.1145-.64796-.9024-1.0296-2.0097-1.0296-3.2047 0-1.1949.38164-2.30215 1.0296-3.20459.16106-.22431.47346-.27559.69777-.11453z"
      />
      <path
        clip-rule="evenodd"
        d="m9.5 12c0-1.3807 1.1193-2.50001 2.5-2.50001s2.5 1.11931 2.5 2.50001-1.1193 2.5-2.5 2.5-2.5-1.1193-2.5-2.5zm2.5-1.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5z"
        fill-rule="evenodd"
      />
    </g>
  </svg>

  <svg
    v-else-if="name === 'insights'"
    class="fill-current"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path
      d="M488.4 492h-21.93V173.54a26.91 26.91 0 00-26.89-26.89h-49.02a26.91 26.91 0 00-26.88 26.89V492h-55.7V317.82a26.91 26.91 0 00-26.88-26.88h-49.02a26.91 26.91 0 00-26.88 26.88V492h-55.7v-90.2a26.91 26.91 0 00-26.88-26.89H73.6a26.91 26.91 0 00-26.88 26.89V492H23.6a10 10 0 100 20h464.8a10 10 0 100-20zm-358.9 0H66.72v-90.2c0-3.8 3.08-6.89 6.88-6.89h49.02c3.8 0 6.88 3.1 6.88 6.89V492zM288 492h-62.8V317.82c0-3.79 3.1-6.88 6.89-6.88h49.02c3.8 0 6.88 3.09 6.88 6.88V492zm158.48 0h-62.8V173.54c0-3.8 3.1-6.89 6.89-6.89h49.02c3.8 0 6.89 3.1 6.89 6.89V492zM466.44 10.52A9.97 9.97 0 00455.95.02l-.48-.02h-60.5a10 10 0 100 20h37.35l-98.85 98.86-37.28-37.28a10 10 0 00-14.15 0L102.27 261.35a10 10 0 0014.15 14.14l172.7-172.7 37.28 37.28a10 10 0 0014.14 0L446.47 34.14v33.81a10 10 0 1020 0V11l-.03-.48z"
    />
    <circle cx="75.64" cy="303.31" r="10" />
  </svg>

  <svg
    v-else-if="name === 'arrow'"
    class="fill-current"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    s
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 492 492"
    style="enable-background: new 0 0 492 492"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12    C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084    c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864    l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"
        />
      </g>
    </g>
  </svg>

  <svg
    v-else-if="name === 'privacyHide'"
    class="fill-current"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 469.44 469.44"
  >
    <path d="M231.15 160.37l67.2 67.2.32-3.52c0-35.3-28.7-64-64-64l-3.52.32z" />
    <path
      d="M234.67 117.39c58.88 0 106.66 47.78 106.66 106.66 0 13.76-2.77 26.88-7.57 38.94l62.4 62.4a253.36 253.36 0 0073.28-101.34c-37.01-93.65-128-160-234.77-160A249.5 249.5 0 00149.66 79l46.08 45.97c12.05-4.7 25.17-7.57 38.93-7.57zM21.33 59.25l48.64 48.64 9.71 9.71A252.68 252.68 0 000 224.05c36.9 93.66 128 160 234.67 160 33.06 0 64.64-6.4 93.54-18.02l9.07 9.06 62.19 62.3 27.2-27.1L48.53 32.05l-27.2 27.2zm117.98 117.87l32.96 32.96a67.6 67.6 0 00-1.6 13.97c0 35.31 28.69 64 64 64 4.8 0 9.38-.64 13.86-1.6l32.96 32.96c-14.18 7.04-29.97 11.31-46.82 11.31-58.88 0-106.67-47.79-106.67-106.67 0-16.85 4.27-32.64 11.3-46.93z"
    />
  </svg>
  <svg
    v-else-if="name === 'privacyShow'"
    class="fill-current"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 461.31 461.31"
  >
    <path
      d="M230.66 156.42c-40.96 0-74.24 33.28-74.24 74.24s33.28 74.24 74.24 74.24 74.24-33.28 74.24-74.24-33.28-74.24-74.24-74.24zm-5.64 52.22c-9.21 0-16.9 7.68-16.9 16.9h-24.57c.51-23.04 18.95-41.48 41.47-41.48v24.58z"
    />
    <path
      d="M455.94 215.3c-25.1-31.24-114.7-133.12-225.28-133.12S30.46 184.06 5.38 215.3c-7.17 8.7-7.17 21.5 0 30.72 25.08 31.23 114.68 133.12 225.28 133.12s200.19-101.9 225.28-133.12c7.16-8.7 7.16-21.5 0-30.72zM230.66 338.18c-59.4 0-107.52-48.13-107.52-107.52s48.12-107.52 107.52-107.52 107.52 48.12 107.52 107.52-48.13 107.52-107.52 107.52z"
    />
  </svg>
  <svg
    v-else-if="name === 'options'"
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current"
    viewBox="0 0 512 512"
  >
    <path
      d="m453.332031 512h-394.664062c-32.363281 0-58.667969-26.304688-58.667969-58.667969v-394.664062c0-32.363281 26.304688-58.667969 58.667969-58.667969h394.664062c32.363281 0 58.667969 26.304688 58.667969 58.667969v394.664062c0 32.363281-26.304688 58.667969-58.667969 58.667969zm-394.664062-480c-14.699219 0-26.667969 11.96875-26.667969 26.667969v394.664062c0 14.699219 11.96875 26.667969 26.667969 26.667969h394.664062c14.699219 0 26.667969-11.96875 26.667969-26.667969v-394.664062c0-14.699219-11.96875-26.667969-26.667969-26.667969zm0 0"
    />
    <path
      d="m346.667969 181.332031h-181.335938c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h181.335938c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
    />
    <path
      d="m346.667969 272h-181.335938c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h181.335938c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
    />
    <path
      d="m346.667969 362.667969h-181.335938c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h181.335938c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
    />
  </svg>
  <svg
    v-else-if="name === 'file'"
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current"
    viewBox="-53 1 511 511.99906"
  >
    <g id="surface1">
      <path
        d="M 276.410156 3.957031 C 274.0625 1.484375 270.84375 0 267.507812 0 L 67.777344 0 C 30.921875 0 0.5 30.300781 0.5 67.152344 L 0.5 444.84375 C 0.5 481.699219 30.921875 512 67.777344 512 L 338.863281 512 C 375.71875 512 406.140625 481.699219 406.140625 444.84375 L 406.140625 144.941406 C 406.140625 141.726562 404.65625 138.636719 402.554688 136.285156 Z M 279.996094 43.65625 L 364.464844 132.328125 L 309.554688 132.328125 C 293.230469 132.328125 279.996094 119.21875 279.996094 102.894531 Z M 338.863281 487.265625 L 67.777344 487.265625 C 44.652344 487.265625 25.234375 468.097656 25.234375 444.84375 L 25.234375 67.152344 C 25.234375 44.027344 44.527344 24.734375 67.777344 24.734375 L 255.261719 24.734375 L 255.261719 102.894531 C 255.261719 132.945312 279.503906 157.0625 309.554688 157.0625 L 381.40625 157.0625 L 381.40625 444.84375 C 381.40625 468.097656 362.113281 487.265625 338.863281 487.265625 Z M 338.863281 487.265625 "
      />
      <path
        d="M 305.101562 401.933594 L 101.539062 401.933594 C 94.738281 401.933594 89.171875 407.496094 89.171875 414.300781 C 89.171875 421.101562 94.738281 426.667969 101.539062 426.667969 L 305.226562 426.667969 C 312.027344 426.667969 317.59375 421.101562 317.59375 414.300781 C 317.59375 407.496094 312.027344 401.933594 305.101562 401.933594 Z M 305.101562 401.933594 "
      />
      <path
        d="M 194.292969 357.535156 C 196.644531 360.007812 199.859375 361.492188 203.320312 361.492188 C 206.785156 361.492188 210 360.007812 212.347656 357.535156 L 284.820312 279.746094 C 289.519531 274.796875 289.148438 266.882812 284.203125 262.308594 C 279.253906 257.609375 271.339844 257.976562 266.765625 262.925781 L 215.6875 317.710938 L 215.6875 182.664062 C 215.6875 175.859375 210.121094 170.296875 203.320312 170.296875 C 196.519531 170.296875 190.953125 175.859375 190.953125 182.664062 L 190.953125 317.710938 L 140 262.925781 C 135.300781 257.980469 127.507812 257.609375 122.5625 262.308594 C 117.617188 267.007812 117.246094 274.800781 121.945312 279.746094 Z M 194.292969 357.535156 "
      />
    </g>
  </svg>
  <svg
    v-else-if="name === 'trash'"
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current"
    viewBox="-40 0 427 427.00131"
  >
    <path
      d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"
    />
    <path
      d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"
    />
    <path
      d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"
    />
    <path
      d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"
    />
  </svg>
</template>

<script>
export default {
  props: ['name'],
};
</script>

<style></style>
